import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Keyboard, Platform, Pressable, View } from 'react-native';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { H5View } from '../../Components/Typography/H5View';
import { HeaderButtonView } from '../../Components/Navigation/HeaderButtonView';
import { PressableButtonView } from '../Buttons/PressableButtonView';
import { getIsLandscape, getScreenOffset } from '../../Hooks/UseOrientation';
export const HeaderView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.header,
    style(theme, mediaQuery, window, props) {
        var _a;
        return {
            container: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, props.headerTransparent && {
                position: 'absolute',
                top: getScreenOffset().value.top || 0,
                left: 0,
                right: 0,
                zIndex: 1
            }), getIsLandscape().value && {
                paddingTop: 5,
                paddingLeft: getScreenOffset().value.left,
                paddingRight: getScreenOffset().value.right
            }), getIsLandscape().value && Platform.OS === 'android' && {
                paddingTop: 10,
            }), props.headerTransparent && Platform.OS === 'android' && !getIsLandscape().value && {
                paddingTop: 5,
            }), getIsLandscape().value && Platform.OS === 'ios' && props.headerTransparent && {
                top: 0
            }), props.containerStyle),
            header: Object.assign(Object.assign(Object.assign({ minHeight: 64, paddingVertical: 10, paddingHorizontal: 20 }, Platform.select({
                default: {},
                android: {
                    paddingHorizontal: 15,
                },
                web: {
                    paddingVertical: 20
                }
            })), { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center' }), props.reverseHeader && {
                flexDirection: 'row-reverse',
            }),
            start: {},
            end: Object.assign({}, !props.removeHeaderEndStyle && Object.assign({ flex: 1, flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end' }, props.reverseHeader && {
                flexDirection: 'row-reverse',
                justifyContent: 'flex-start',
            })),
            title: Object.assign({ textAlign: 'center', marginBottom: 20, color: props.tintColor || ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.text_color) || '#040504' }, props.titleStyle),
        };
    }
})(({ style, headerStartStyle, headerEndStyle, hideBackButton, containerStyle, tintColor, onBack, isDismissButton, interactions, title }) => {
    return (_jsxs(Pressable, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyle], onPress: Keyboard.dismiss, children: [_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.header, children: [_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.start, headerStartStyle], children: !hideBackButton && (_jsx(HeaderButtonView, { tintColor: tintColor, canGoBack: true, onPress: onBack, containerStyle: { marginStart: 0, marginEnd: 0 }, isDismissButton: isDismissButton, forceShow: true })) }), _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.end, headerEndStyle], children: interactions === null || interactions === void 0 ? void 0 : interactions.map((interaction, i) => (_jsx(PressableButtonView, { action: interaction.action, type: interaction.type || 'dense', color: tintColor, text: interaction.text, iconLeft: interaction.icon, imageLeft: interaction.image, onPress: interaction.onPress, containerStyle: [interaction.containerStyle, i < interactions.length - 1 && { marginEnd: 10 }] }, interaction.action))) })] }), !!title && (_jsx(H5View, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: title }))] }));
});
